import * as React from 'react'
import styled from '@emotion/styled'
import { MasterLegalAgreementType, TradingEntity, ValidationIssue } from 'api'
import { MultiComboboxField, MultiComboboxProps } from 'view/components/options'
import { ToggleField } from 'view/components/toggle'
import { COUNTERPARTY_COLOURS } from 'view/routes/staging/SendRFQPanel/rfqPanelStyles'
import { getEnumValues } from 'model'
import { Locale, Translation } from 'locale'
import * as constants from 'view/styles/constants'

interface MasterLegalAgreementMultiComboBoxProps extends Omit<MultiComboboxProps<TradingEntity, string>, 'optionKeys'> {
  onUpdateDefaultAgreement: (tradingEntityId: string, checked: boolean) => unknown
  defaultAgreement: MasterLegalAgreementType | null
  validationIssues: ValidationIssue[]
  validationField: string | string[]
}

const ToggleWrapper = styled.div`
  display: flex;

  & > div:not(:first-of-type) {
    padding-left: 10px;
    margin-left: 10px;
    border-left: 1px solid ${constants.CORE_PRIMARY_3};
  }
`

export const MasterLegalAgreementMultiComboBox: React.FC<MasterLegalAgreementMultiComboBoxProps> = props => {
  const { onUpdateDefaultAgreement, defaultAgreement, value } = props

  const optionKeys = getEnumValues(MasterLegalAgreementType)

  const DefaultAgreementToggles = (optionKey: MasterLegalAgreementType) => {
    return (
      <ToggleWrapper>
        <ToggleField
          label={Locale.translate(Translation.TC_DEFAULT_AGREEMENT)}
          checked={defaultAgreement === optionKey}
          readOnly={value.length === 1}
          onUpdate={(checked: boolean) => onUpdateDefaultAgreement(optionKey, checked)}
        />
      </ToggleWrapper>
    )
  }

  return (
    <MultiComboboxField
      optionKeys={optionKeys}
      noItemsText={Locale.translate(Translation.SC_N_MASTER_LEGAL_AGREEMENTS, { count: 0 })}
      placeholder={Locale.translate(Translation.SC_SELECT_MASTER_LEGAL_AGREEMENT)}
      clearButtonLabel={Locale.translate(Translation.SC_REMOVE_MASTER_LEGAL_AGREEMENTS)}
      optionColorPalette={COUNTERPARTY_COLOURS}
      selectedOptionCustomComponent={DefaultAgreementToggles}
      label={Locale.translate(Translation.TC_MASTER_LEGAL_AGREEMENTS)}
      {...props}
    />
  )
}
